const INDICATOR_ROLE_TYPES = new Set(['calculation', 'input']);

/**
 * Merges PATCH request fields into the API response so Redux can update local state
 * when the server returns a partial body (e.g. type change without `indicator_type`).
 */
export function enrichIndicatorPatchPayload(
  response: Record<string, any> | undefined | null,
  indicatorId: number | string | undefined,
  requestData: Record<string, any> | undefined,
): Record<string, any> | undefined {
  const hasResponse = response != null && typeof response === 'object';
  const hasRequest = requestData != null && typeof requestData === 'object';

  if (!hasResponse && !hasRequest) return undefined;

  const payload: Record<string, any> = {
    ...(hasResponse ? response : {}),
    id: hasResponse ? response!.id ?? indicatorId : indicatorId,
  };

  if (!hasRequest) return payload;

  const requestedType = String(requestData.type ?? '').toLowerCase();
  if (INDICATOR_ROLE_TYPES.has(requestedType)) {
    payload.indicator_type = requestedType;
  }

  if (requestData.data_type != null && payload.data_type == null) {
    payload.data_type = requestData.data_type;
  }

  return payload;
}

export default enrichIndicatorPatchPayload;
